

import React from "react";

import digitalIdentityImg from "../../images/IDENTY.png";
import profitGrowthImg from "../../images/HIGHR.webp";
import smartGrowthImg from "../../images/HIHJERGROTH.png";
import customerExperienceImg from "../../images/EXPRIENCE.png";

const BusinessBenefits = () => {
  const sections = [
    {
      id: 1,
      title: "Stronger Digital Identity",
      description:
        "A strong digital identity builds trust, credibility, and influence in the online world. From consistent messaging to professional branding, businesses can connect deeply with their audience and stand out in a crowded market.",
      imageSrc: digitalIdentityImg,
      imageAlt: "Digital identity illustration",
    },
    {
      id: 2,
      title: "Higher Profit",
      description:
        "With intelligent strategies and optimized operations, your business can unlock higher profitability. Data-driven decision-making helps improve efficiency, reduce cost leakage, and maximize revenue growth.",
      imageSrc: profitGrowthImg,
      imageAlt: "Profit growth illustration",
    },
    {
      id: 3,
      title: "Smarter Growth",
      description:
        "Scalable systems, well-planned frameworks, and accurate market insights help businesses grow steadily. Smarter growth ensures long-term sustainability without compromising customer value.",
      imageSrc: smartGrowthImg,
      imageAlt: "Smart growth illustration",
    },
    {
      id: 4,
      title: "Enhanced Customer Experience",
      description:
        "A delightful customer journey creates loyalty and retention. Personalized interactions, seamless communication, and proactive support improve customer satisfaction and brand recall.",
      imageSrc: customerExperienceImg,
      imageAlt: "Customer experience illustration",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "5px 20px",
        color: "#1e293b",
      }}
      className="business-benefits"
    >
      {/* Responsive Media Queries */}
      <style>{`
          .title-main {
            font-size: 2.7rem;
            font-weight: 800;
            text-align: center;
            color: #0f172a;
            margin-bottom: 18px;
          }
          .subtitle {
            text-align: center;
            max-width: 750px;
            margin: 0 auto 60px;
            font-size: 1.15rem;
            // line-height: 1.65;
            color: #465569;
          }
          .benefit-wrap {
            display: flex;
            flex-direction: column;
            gap: 17px;
          }
          .benefit-box {
            display: flex;
            flex-direction: column;
            gap: 45px;
            align-items: center;
          }
          .benefit-text {
            flex: 1;
            max-width: 750px;
          }
          .benefit-title {
            font-size: 2rem;
            font-weight: 700;
            margin-bottom: 16px;
            position: relative;
            padding-bottom: 10px;
          }
          .benefit-title::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            height: 4px;
            width: 65px;
            border-radius: 3px;
            background: #e66d33;
          }
          .benefit-desc {
            font-size: 1.12rem;
            // line-height: 1.9;
            // text-align: justify;
            color: #475569;
            letter-spacing: 0.3px;
          }
          .image-box img {
            width: 260px;
            height: 200px;
            border-radius: 14px;
            object-fit: contain; /* NO CROPPING */
            background: #ffffff;
            padding: 10px;
            // box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .image-label {
            margin-top: 10px;
            text-align: center;
            font-size: .95rem;
            font-style: italic;
            color: #64748b;
          }

          /* Tablet */
          @media (min-width: 768px) {
            .benefit-box {
              flex-direction: row;
            }
            .right-block {
              flex-direction: row-reverse;
            }
          }

          /* Mobile */
          @media (max-width: 600px) {
            .title-main {
              font-size: 2.1rem;
            }
            .benefit-title {
              font-size: 1.55rem;
            }
            .image-box img {
              width: 220px;
              height: 160px;
            }
          }
        `}</style>

      <h1 className="title-main">What Maamaas Brings to <span style={{ color: "#e66d33" }}> Your Business</span></h1>
      <p className="subtitle">
        Transform your business with our powerful solutions designed to elevate
        your digital brand and deliver meaningful, measurable growth.
      </p>

      <div className="benefit-wrap">
        {sections.map((row, index) => (
          <div
            key={row.id}
            className={`benefit-box ${index % 2 !== 0 ? "right-block" : ""}`}
          >
            <div className="benefit-text">
              <h2 className="benefit-title">{row.title}</h2>
              <p className="benefit-desc">{row.description}</p>
            </div>

            <div className="image-box">
              <img src={row.imageSrc} alt={row.imageAlt} />
              <div className="image-label">{row.imageAlt}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessBenefits;
